// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2ixV-","col":"Table_col__1Gwch","fulfillmentStatus":"Table_fulfillmentStatus__BLkT2","emailCol":"Table_emailCol__2-b11"};